import { render, staticRenderFns } from "./ocrUpdDialog.vue?vue&type=template&id=252010e1&scoped=true"
import script from "./ocrUpdDialog.vue?vue&type=script&lang=js"
export * from "./ocrUpdDialog.vue?vue&type=script&lang=js"
import style0 from "./ocrUpdDialog.vue?vue&type=style&index=0&id=252010e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252010e1",
  null
  
)

export default component.exports